import { GAME_MODE, NotesSection } from '~/interfaces';
import GameState from '~/modules/game-engine/game-state/game-state';
import { getSingerAtSection } from '~/modules/game-engine/game-state/helpers/turns';
import { PlayerNumber } from '~/modules/players/player-number';

/**
 * The singers sharing one track. Answered by `GameState`, which is also what the score reads - a
 * second copy of the rule here would be one the scoring could silently drift away from.
 */
export const getTrackSingers = (trackIndex: number): PlayerNumber[] => GameState.getTrackSingers(trackIndex);

/**
 * Who is holding the microphone, or null when nobody is taking turns. Turns cycle through the
 * singers sharing the track, and one singer on a track has nobody to pass to.
 */
export const getMicrophoneHolder = (): PlayerNumber | null => {
  if (GameState.getSingSetup()?.mode !== GAME_MODE.PASS_THE_MIC) return null;

  const first = GameState.getPlayers()[0];
  if (!first) return null;

  const singers = getTrackSingers(first.getTrackIndex());
  if (singers.length < 2) return null;

  const turn = getSingerAtSection(first.getTrack().changes, first.getCurrentSection()?.start ?? null, singers.length);

  return singers[turn] ?? null;
};

/**
 * Whether a section of the track is this singer's to sing, which is what they can be marked on.
 * Outside pass the mic every singer sings every section of their own track, and a singer with
 * nobody to pass to sings all of theirs.
 */
export const ownsSection = (playerNumber: PlayerNumber, section: NotesSection): boolean =>
  GameState.ownsSection(playerNumber, section);
